import { useState } from "react";
import { Volume2, VolumeX } from "lucide-react";
import { isSoundEnabled, setSoundEnabled } from "@/utils/flickSound";

export const SoundToggle = () => {
  const [on, setOn] = useState(isSoundEnabled);

  const toggle = (e) => {
    e.stopPropagation();
    setSoundEnabled(!on);
    setOn(!on);
  };

  return (
    <button
      type="button"
      data-testid="sound-toggle"
      aria-pressed={on}
      aria-label={on ? "Mute flip sound" : "Unmute flip sound"}
      title={on ? "Flip sound on" : "Flip sound off"}
      onClick={toggle}
      className="absolute bottom-5 right-5 z-20 flex h-10 w-10 items-center justify-center rounded-full border border-gold/30 bg-white/[0.03] text-gold/70 backdrop-blur-sm transition-colors duration-300 hover:border-gold/60 hover:text-gold focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold/60"
    >
      {on ? (
        <Volume2 size={16} strokeWidth={1.75} />
      ) : (
        <VolumeX size={16} strokeWidth={1.75} />
      )}
    </button>
  );
};
